export class TemplateSingleLineInspection {
    id = 0;
    description = '';
}
